
import {
  performance,
} from "plugins/user-timing-polyfill"

import RemoteState from "./remote_state"


function refresh_component() {
  const START_MARK_NAME = "spacious_mark__app_authentication_onLoad__refresh_component__start"
  const END_MARK_NAME   = "spacious_mark__app_authentication_onLoad__refresh_component__end"

  performance.mark(START_MARK_NAME)

  RemoteState.refreshAndUpdateComponentPromise()
  .then(() => {
    performance.mark(END_MARK_NAME)

    const marks = performance.getEntriesByType("mark")
    const isStartMarkFound = marks.find((mark) => mark.name === START_MARK_NAME)

    if(!isStartMarkFound) { return }

    performance.measure(
      "spacious_measure__app_authentication_onLoad__refresh_component",
      START_MARK_NAME,
      END_MARK_NAME,
    )
  })
  .done()
}
function contact_info_caching() {
  import(
    "./contact_info_caching/index"
  )
  .then(({onLoad: ContactInfoCachingOnLoad}) => {
    performance.mark("spacious_mark__ContactInfoCachingOnLoad__start")

    ContactInfoCachingOnLoad()
    .then(() => {
      performance.mark("spacious_mark__ContactInfoCachingOnLoad__end")
      performance.measure(
        "spacious_measure__ContactInfoCachingOnLoad",
        "spacious_mark__ContactInfoCachingOnLoad__start",
        "spacious_mark__ContactInfoCachingOnLoad__end",
      )
    })
    .done()
  })
}

const onLoad = () => {
  refresh_component()

  contact_info_caching()
}

export default onLoad
